import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WorkflowService } from '../../modules/workFlow/services/workflow-service';

@Injectable({
  providedIn: 'root'
})
export class TasksCountService {
  private tasksCountSubject = new BehaviorSubject<number>(0);
  public tasksCount$ = this.tasksCountSubject.asObservable();

  constructor(private workflowService: WorkflowService) {}

  refreshTasksCount(): void {
    this.workflowService.getMyTasksCount().subscribe({
      next: (res) => {
        if (res && res.success) {
          this.tasksCountSubject.next(res.value);
        }
      },
      error: (err) => {
        console.error('Error refreshing tasks count:', err);
      }
    });
  }

  getCurrentCount(): number {
    return this.tasksCountSubject.value;
  }
}
